import React, { useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import './TileComponent.css';

const TileComponent = ({ title, price, description, url, category, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);

  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  console.log('Description:', description);


  return (
    <Box className="tile-container">
      {/* Product Header with Microsoft Logo and Title */}
      <Box display="flex" alignItems="center" className="product-header">
        <img src="/Microsoft_logo.png" alt="Microsoft Logo" className="microsoft-logo" />
        <Typography variant="h6" className="product-title">
          {title}
        </Typography>
      </Box>

      {/* Product Code and Description */}
      <Box className="product-info">
        {description && (
          <Typography variant="body1" className="product-description">
            {description}
          </Typography>
        )}
        {url && (
          <Typography variant="body2" className="product-url">
            <a href={url} target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          </Typography>
        )}
      </Box>


      {/* Add to Cart Section */}
      <Box display="flex" alignItems="center" justifyContent="space-between" className="add-to-cart-container">
        {/* Quantity Selector */}
        <Box display="flex" alignItems="center">
          <IconButton onClick={decreaseQuantity}>
            <RemoveIcon />
          </IconButton>
          <Typography>{quantity}</Typography>
          <IconButton onClick={increaseQuantity}>
            <AddIcon />
          </IconButton>
        </Box>

        {/* Add to Cart Button */}
        <Button
          variant="contained"
          color="primary"
          startIcon={<ShoppingCartIcon />}
          onClick={() => onAddToCart({ title, quantity })}
        >
          Add to cart
        </Button>
      </Box>
    </Box>
  );
};

export default TileComponent;
